import * as Sentry from '@sentry/react';

import {
  apiTracePropagationTargets,
  createKeyFlowTracesSampler,
  guestAppTransactionName,
  SEATERS_API_BASE_URL,
  shouldInitSentry,
} from '@seaters/constants';

import {
  IS_DEV_SERVER,
  MODE,
  RELEASE,
  SENTRY_DEV_ENABLED,
  SENTRY_DSN,
} from '../../constants/env';

export function sentryInit() {
  if (
    !shouldInitSentry({
      isDevServer: IS_DEV_SERVER,
      devOptIn: SENTRY_DEV_ENABLED,
    })
  ) {
    return;
  }

  const waitingListId =
    new URLSearchParams(window.location.search).get('waitingListId') ??
    undefined;

  Sentry.init({
    dsn: SENTRY_DSN,
    environment: MODE,
    release: RELEASE,
    // Events land in the shared `seaters-app` project — this app has its own
    // client key, but keys do not segment issues. This tag is the only thing
    // separating invitation's errors from the admin SPA's; filter on
    // `app:invitation` in Sentry search.
    initialScope: { tags: { app: 'invitation', waitingListId } },
    integrations: [
      // No router here (the app is query-param driven), so name the span by page, not by slug.
      Sentry.browserTracingIntegration({
        beforeStartSpan: (context) => ({
          ...context,
          name: guestAppTransactionName(context.name),
          attributes: {
            ...context.attributes,
            [Sentry.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE]: 'route',
          },
        }),
      }),
      Sentry.consoleLoggingIntegration({ levels: ['warn', 'error'] }),
    ],
    // v8+ moved this to the top level; passed inside browserTracingIntegration
    // it is silently ignored, and then sentry-trace + baggage never leave the
    // browser, so the Java/Node spans look unparented in Sentry.
    tracePropagationTargets: apiTracePropagationTargets(SEATERS_API_BASE_URL),
    // 10% of pages; guest accept / reject at their KEY_FLOW_RATES rate.
    tracesSampler: createKeyFlowTracesSampler(0.1),
    enableLogs: true,
  });
}
